/**
 * PendingPhotoCard — shown while a photo is being processed by the AI pipeline.
 * Displays a spinner and "Reviewing…" text. Updates via Centrifugo event.
 */

interface Props {
  localPreviewUrl?: string;
}

export function PendingPhotoCard({ localPreviewUrl }: Props) {
  return (
    <div
      data-testid="pending-photo-card"
      className="relative rounded-lg border border-border overflow-hidden bg-muted"
      style={{ aspectRatio: '4/3' }}
    >
      {/* Grey placeholder or local preview */}
      {localPreviewUrl ? (
        <img
          src={localPreviewUrl}
          alt="Uploading..."
          className="w-full h-full object-cover opacity-40"
        />
      ) : (
        <div className="w-full h-full bg-muted" />
      )}

      {/* Overlay with spinner */}
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-background/60">
        <div
          className="w-7 h-7 border-2 border-primary border-t-transparent rounded-full animate-spin"
          aria-hidden="true"
        />
        <span className="text-xs font-medium text-foreground">Reviewing…</span>
      </div>
    </div>
  );
}
